module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-apollo/gatsby-browser.js'),
      options: {"plugins":[],"uri":"https://virtual-lolly-p12e-mnm.netlify.app/.netlify/functions/newLolly"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
